module.exports = __webpack_public_path__ + "static/img/4-8.92f425d4.png";